import React, { lazy } from 'react';
interface GlobalBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'side';
  className?: string;
}
const BADGE_COMPACT = 'https://cdn.magicpatterns.com/uploads/wPd1mW6ZcQQqRUugCYw3nE/Screenshot_43_(1).png';
const BADGE_WIDE = 'https://cdn.magicpatterns.com/uploads/4y1KzdAdavfYV1MJaNZdHB/Layer_1.png';
export function GlobalBadge({
  size = 'sm',
  variant = 'default',
  className = ''
}: GlobalBadgeProps) {
  // Side variant: vertical ribbon-style badge anchored to the edge of an image
  if (variant === 'side') {
    const heightClass = size === 'lg' ? 'h-8' : size === 'md' ? 'h-7' : 'h-6';
    return <span className={`inline-flex items-center justify-center bg-[#1E2B55] shadow-lg rounded-l-full pl-3 pr-1 ${heightClass} ${className} transform transition-transform hover:translate-x-[-2px]`} aria-label="Global product" role="img" data-id="element-5704" data-mp="gezbfjsvlds3">
        <img src={BADGE_WIDE} alt="Global" className="h-full w-auto block brightness-0 invert" loading="lazy" decoding="async" data-id="element-5705" data-mp="2eeukt6its18" />
      </span>;
  }
  const sizeClass = size === 'lg' ? 'h-11' : size === 'md' ? 'h-8' : 'h-6';
  const src = size === 'md' ? BADGE_WIDE : BADGE_COMPACT;
  return <span className={`inline-flex items-center rounded-md shadow-sm overflow-hidden ${sizeClass} ${className}`} aria-label="Global product" role="img" data-id="element-5706" data-mp="35q4ghabwoczc">
      <img src={src} alt="Global" className="h-full w-auto block" loading="lazy" decoding="async" data-id="element-5707" data-mp="1eimqn4h27dv" />
    </span>;
}